import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import { getAuthorities } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/activity-types/ActivityTypesAction";
import * as uiHelpers from "../ActivityTypesUIHelpers";
import { 
  getSelectRow, 
  getHandlerTableChange,  
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useActivityTypesUIContext } from "../ActivityTypesUIContext";

export function ActivityTypesTable({
  deleteActivityTypes
}) {
  // ActivityTypes UI Context
  const activityTypesUIContext = useActivityTypesUIContext();
  const activityTypesUIProps = useMemo(() => {
    return {
      ids: activityTypesUIContext.ids,
      setIds: activityTypesUIContext.setIds,
      queryParams: activityTypesUIContext.queryParams,
      setQueryParams: activityTypesUIContext.setQueryParams,
      openEditActivityTypePage: activityTypesUIContext.openEditActivityTypePage
    };
  }, [activityTypesUIContext]);

  // Getting curret state of ActivityTypes list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.activityTypes }),
    shallowEqual
  );
  const { totalCount, entities, authorities, listLoading } = currentState;
  
  // Authority Parameters
  const { isEditionAuthorized, isDeletionAuthorized } = getAuthorities(authorities);
  
  // ActivityTypes Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getActivityTypes(activityTypesUIProps.queryParams));
    return () => dispatch(actions.cleanActivityTypesState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activityTypesUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "name",
      text: "Adı",
      sort: true,
      sortCaret: sortCaret,
    }
  ];

  const actionColumn = {
    dataField: "action",
    text: "İşlemler",
    formatter: columnFormatters.ActionsColumnFormatter,
    formatExtraData: {
      isEditionAuthorized,
      isDeletionAuthorized,
      openEditActivityTypePage: activityTypesUIProps.openEditActivityTypePage,
      deleteActivityTypes
    },
    classes: "text-right pr-0",
    headerClasses: "text-right pr-3",
    style: {
      minWidth: "100px",
    }
  }

  if (isEditionAuthorized || isDeletionAuthorized) columns.push(actionColumn);

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: activityTypesUIProps.queryParams.pageSize,
    page: activityTypesUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ?? []}
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                activityTypesUIProps.setQueryParams
              )}
              selectRow={getSelectRow({
                entities,
                ids: activityTypesUIProps.ids,
                setIds: activityTypesUIProps.setIds,
                hidden: !isDeletionAuthorized
              })}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}